var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagamentoRealizado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5001,
    cy: 38.3253,
    r: 38.3253,
    fill: "#00D084"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1783 47.0168L52.9017 26.2934L55.6526 29.0443L32.1783 52.5186L21.2665 41.6067L24.0173 38.8558L32.1783 47.0168Z",
    fill: "#F1F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagamentoRealizado);
export default __webpack_public_path__ + "static/media/pagamento_realizado.b61f532f51b548e99cf7680dde7807dc.svg";
export { ForwardRef as ReactComponent };